import { bootstrapApplication } from '@angular/platform-browser';

// Registers moment's Romanian locale data. Without this, MAT_DATE_LOCALE='ro'
// (set in shared.providers.ts) has no effect on the datepicker's MomentDateAdapter:
// moment().locale('ro') silently falls back to its default English locale, which
// is why the datepicker inputs were rendering MM/DD/YYYY instead of DD.MM.YYYY.
import 'moment/locale/ro';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.log(err));
